import { type ProgramFamily, type ProgramType } from 'Program';

export enum ProgramApplicationStatus {
    SubmittedApplication = 'submitted_application',
    SelectedForAdmission = 'selected_for_admission',
    NotSelectedForAdmission = 'not_selected_for_admission',
}

export enum PostApplyInterviewModalType {
    Instant = 'instant',
    Optional = 'optional',
    Excluded = 'excluded',
}

interface ProgramApplicationAdminOnlyFields {
    admissionsDecision: string | null;
    admissionsInterviewer: string | null;
    admissionsInterviewDate: number | null;
    admissionsFinalDecision: string | null;
    admissionsValarOptIn: boolean;

    admissionsMotivationAssessmentScore: string | null;
    admissionsContributionAssessmentScore: string | null;
    admissionsInsightfulnessAssessmentScore: string | null;

    // LEGACY
    admissionsMotivationScore: string | null;
    admissionsContributionScore: string | null;
    admissionsInsightfulnessScore: string | null;
}

interface ProgramApplicationBaseFields {
    id: string;
    appliedAt: number;
    cohortId: string;
    cohortName: string;
    cohortProgramGuideUrl: string;
    earlyAdmissionEligible: boolean;
    eligibleForInstantInterviewModal: boolean;
    eligibleForOptionalInterviewModal: boolean;
    declineScholarshipConsideration: boolean | null; // when ProgramFamilyFormDatum is null, this is null
    interviewConducted: boolean;
    interviewScheduled: boolean;
    invitedToInterview: boolean;
    invitedToInterviewUrl: string;
    invitedToPreRecordedInterview: boolean;
    programFamily: ProgramFamily;
    programType: ProgramType;
    status: ProgramApplicationStatus;
    willNotInterview: boolean;
    willoInviteLink: string | null;
    shownInstantInterviewModal: boolean;
    shownOptionalInterviewModal: boolean;
    postApplyInterviewModalType: PostApplyInterviewModalType | null;
    // Server-resolved Calendly calendar for the post-apply interview modal, based on the user's
    // (server-derived) country tier. Passed down so the modal doesn't re-derive the calendar from a
    // staleness-prone client value. See ProgramApplication#post_apply_interview_modal_calendly_url.
    postApplyInterviewModalCalendlyUrl: string;
    admissionsInterviewScheduled: boolean;
    decisionDate: number | null;
}

export type ProgramApplication<adminOnlyFields = false> = adminOnlyFields extends true
    ? ProgramApplicationAdminOnlyFields & ProgramApplicationBaseFields
    : ProgramApplicationBaseFields;
